import { throwApiError } from '@/shared/utils/apiResponse';
import { apiDelete, apiGet, apiPatch, apiPost } from '@/shared/utils/requestBuilder';

import type { InternalChatRespostaRapida } from '../../types';

const unwrap = <T>(body: unknown): T => {
  if (typeof body === 'object' && body !== null && 'data' in body) {
    return (body as { data: T }).data;
  }
  return body as T;
};

const jsonOk = async <T>(response: Response, fallbackMsg: string): Promise<T> => {
  if (!response.ok) await throwApiError(response, fallbackMsg);
  const body = (await response.json()) as unknown;
  return unwrap<T>(body);
};

export const respostasRapidasService = {
  list: async (): Promise<{ items: InternalChatRespostaRapida[] }> => {
    const response = await apiGet('/admin/chat/respostas-rapidas');
    return jsonOk<{ items: InternalChatRespostaRapida[] }>(
      response,
      'Erro ao carregar respostas rápidas',
    );
  },
  create: async (input: {
    atalho: string;
    conteudo: string;
    compartilhada?: boolean;
  }): Promise<InternalChatRespostaRapida> => {
    const response = await apiPost('/admin/chat/respostas-rapidas', input);
    return jsonOk<InternalChatRespostaRapida>(response, 'Erro ao criar resposta rápida');
  },
  update: async (
    respostaId: string,
    input: { atalho?: string; conteudo?: string },
  ): Promise<InternalChatRespostaRapida> => {
    const response = await apiPatch(`/admin/chat/respostas-rapidas/${respostaId}`, input);
    return jsonOk<InternalChatRespostaRapida>(response, 'Erro ao atualizar resposta rápida');
  },
  remove: async (respostaId: string): Promise<void> => {
    const response = await apiDelete(`/admin/chat/respostas-rapidas/${respostaId}`);
    if (!response.ok && response.status !== 204) {
      await throwApiError(response, 'Erro ao remover resposta rápida');
    }
  },
};
